import { render } from "./StepTableRoles.vue?vue&type=template&id=731e403a&scoped=true"
import script from "./StepTableRoles.vue?vue&type=script&lang=js"
export * from "./StepTableRoles.vue?vue&type=script&lang=js"

import "./StepTableRoles.vue?vue&type=style&index=0&id=731e403a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731e403a"]])

export default __exports__